import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/icon_open_b2b.png'
import _imports_1 from '@/assets/image/icon/icon_open_d2c.png'


const _withScopeId = n => (_pushScopeId("data-v-909876ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-stores" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "store-list" }
const _hoisted_4 = { class: "store-header flex-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "current-shop"
}
const _hoisted_8 = {
  class: "list-item-row",
  style: {"margin-top":"12px"}
}
const _hoisted_9 = { class: "item-label" }
const _hoisted_10 = { class: "item-value shop-name" }
const _hoisted_11 = { class: "list-item-row" }
const _hoisted_12 = { class: "item-label" }
const _hoisted_13 = {
  key: 0,
  class: "deliver-num"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/报警灯.png",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_15 = { class: "tips" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "list-item-row" }
const _hoisted_18 = { class: "item-label" }
const _hoisted_19 = { class: "list-item-row" }
const _hoisted_20 = { class: "item-label" }
const _hoisted_21 = { class: "flex-center" }
const _hoisted_22 = { class: "date" }
const _hoisted_23 = { class: "list-item-row" }
const _hoisted_24 = { class: "item-label" }
const _hoisted_25 = { class: "item-value" }
const _hoisted_26 = { class: "list-item-row" }
const _hoisted_27 = { class: "item-label" }
const _hoisted_28 = { class: "item-value" }
const _hoisted_29 = {
  key: 2,
  class: "list-item-row"
}
const _hoisted_30 = { class: "item-label" }
const _hoisted_31 = { class: "item-value" }
const _hoisted_32 = {
  key: 3,
  class: "list-item-row"
}
const _hoisted_33 = { class: "item-label" }
const _hoisted_34 = { class: "item-value" }
const _hoisted_35 = { class: "flex-center" }
const _hoisted_36 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_37 = {
  key: 1,
  src: _imports_1,
  alt: ""
}

import { computed, onMounted, Ref, ref } from 'vue'
import { judgePlatLogo, mapShopPlatform } from './data'
import { isD2C, isJA } from '@/store'
import { t } from '@/plugins/i18n'
import { getUserShopListApi } from '@/apis/user'
import { useStore } from 'vuex'
import { UseType } from '@/common/const'
import { CustomerShopRespDTO } from '@/apis/interface/customer'
import dayjs from 'dayjs'
import { formatPrice } from '@/views/fund/FundList/data'
import { myShopIcons } from '@/store/modules/bussiness'
import bus from '@/util/useBus'
import { request } from '@/config/request/interceptors'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const icon_check_type = isD2C() ? 'd2c' : 'b2b'

const store = useStore()
const user = computed(() => store.getters.user)
const curShop = store.getters.curShop

const isShowMore = ref(false)
const shopList: Ref<CustomerShopRespDTO[]> = ref([])
const loading1 = ref(false)
const loading2 = ref(false)
const date = dayjs().subtract(1, 'day').format('MM-DD')
const canUseCoupon = ref(0)


/** 获取店铺列表 */
const getShopList = async () => {
    !isShowMore.value && (loading1.value = true)
    isShowMore.value && (loading2.value = true)
    const formData = {
        accountType: user.value?.accountType,
        customerId: user.value?.customerShopList.find((e: any) => e.customerShopId === curShop).customerId,
        customerShopId: curShop,
        mainCustomerId: user.value?.mainCustomerId,
        systemSource: isD2C() ? UseType.d2c : UseType.b2b,
        viewFirstTenStores: isShowMore.value ? 0 : 1
    }

    const res = await getUserShopListApi(formData)
    shopList.value = [
        ...shopList.value,
        ...(res.data?.customerShopList ?? [])
    ]
    !isShowMore.value && (loading1.value = false)
    isShowMore.value && (loading2.value = false)
}

bus.on('addShop', () => {
    shopList.value = []
    getShopList()
})

onMounted(async () => {
    getShopList()
})

/** 获取更多 */
const more = () => {
    isShowMore.value = true
    getShopList()
}

// 判断数字如果没有就返回 -
const judgeNumFields = (val: any) => {
    if (val) {
        return val
    } else {
        return 0
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("我的店铺")), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "list-item"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("img", {
              referrerPolicy: "no-referrer",
              src: _unref(myShopIcons)[Number(item?.shopPlatform)],
              height: "24"
            }, null, 8, _hoisted_6),
            (_unref(curShop) === item.customerShopId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)('当前店铺')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('店铺名称')), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(item.customerShopName), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('余额')), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["item-value", Number(item?.availableAmount) < 0 ? 'font-red' : '']),
              style: {"font-size":"18px","font-weight":"700"}
            }, _toDisplayString(`${_unref(formatPrice)(judgeNumFields(item?.availableAmount))}${_unref(t)('元')}`), 3)
          ]),
          (Number(item?.overdueCanotDeliverNum))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('有包裹因欠费而无法发货，请尽快转账')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16)),
          _createVNode(_component_el_divider, { style: {"margin":"16px 0"} }),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('待处理异常订单')), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["item-value", Number(item.abnormalOrderNum) > 0 ? 'font-red' : ''])
            }, _toDisplayString(judgeNumFields(Number(item?.abnormalOrderNum))), 3)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('待支付账单')), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["item-value", Number(item.unpaidBillNum) > 0 ? 'font-red' : ''])
            }, _toDisplayString(judgeNumFields(Number(item?.unpaidBillNum))), 3)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(date)) + " " + _toDisplayString(_unref(t)('对应情报')), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('下单金额')), 1),
            _createElementVNode("span", _hoisted_25, _toDisplayString(judgeNumFields(Number(item?.orderAmount))) + _toDisplayString(item?.orderAmount ?
                        _unref(t)('元') : ''), 1)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(t)('订单数量')), 1),
            _createElementVNode("span", _hoisted_28, _toDisplayString(judgeNumFields(Number(item?.orderCount))), 1)
          ]),
          (_unref(isD2C)())
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('API下单量')), 1),
                _createElementVNode("span", _hoisted_31, _toDisplayString(judgeNumFields(Number(item?.apiOrderCount))), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('发货量')), 1),
                _createElementVNode("span", _hoisted_34, _toDisplayString(judgeNumFields(Number(item?.yesterdayShipmentsQuantity))), 1)
              ]))
        ]))
      }), 128)),
      (shopList.value.length === 10 && !isShowMore.value || loading2.value)
        ? _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "more cursor-pt",
            onClick: more
          }, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('展开全部数据')), 1),
              (!_unref(isD2C)())
                ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                : (_openBlock(), _createElementBlock("img", _hoisted_37))
            ])
          ], 512)), [
            [_directive_loading, loading2.value]
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})